// extracted by mini-css-extract-plugin
export default {"main":"NetworkTabs_main__mz18L","tab":"NetworkTabs_tab__22OQf","tabContainer":"NetworkTabs_tabContainer__Dvg2k","pillList":"NetworkTabs_pillList__H6Euq"};